/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getSubscriptionPlans } from 'app/entities/subscription-plan/subscription-plan.reducer';
import { PaymentType } from 'app/shared/model/enumerations/payment-type.model';
import { PaymentReason } from 'app/shared/model/enumerations/payment-reason.model';
import { createEntity, getEntity, reset, updateEntity } from './subscription-payment.reducer';

export const SubscriptionPaymentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const subscriptionPlans = useAppSelector(state => state.subscriptionPlan.entities);
  const subscriptionPaymentEntity = useAppSelector(state => state.subscriptionPayment.entity);
  const loading = useAppSelector(state => state.subscriptionPayment.loading);
  const updating = useAppSelector(state => state.subscriptionPayment.updating);
  const updateSuccess = useAppSelector(state => state.subscriptionPayment.updateSuccess);
  const paymentTypeValues = Object.keys(PaymentType);
  const paymentReasonValues = Object.keys(PaymentReason);

  const handleClose = () => {
    navigate(`/subscription-payment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getSubscriptionPlans({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...subscriptionPaymentEntity,
      ...values,
      subscriptionPlan: subscriptionPlans.find(it => it.id.toString() === values.subscriptionPlan?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          paymentType: 'CASH',
          paymentReason: 'NEW',
          ...subscriptionPaymentEntity,
          subscriptionPlan: subscriptionPaymentEntity?.subscriptionPlan?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.subscriptionPayment.home.createOrEditLabel" data-cy="SubscriptionPaymentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.subscriptionPayment.home.createOrEditLabel">
              Create or edit a SubscriptionPayment
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="subscription-payment-id"
                  label={translate('tinyMedicRestApp.subscriptionPayment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPayment.paymentType')}
                id="subscription-payment-paymentType"
                name="paymentType"
                data-cy="paymentType"
                type="select"
              >
                {paymentTypeValues.map(paymentType => (
                  <option value={paymentType} key={paymentType}>
                    {translate(`tinyMedicRestApp.PaymentType.${paymentType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPayment.paymentReason')}
                id="subscription-payment-paymentReason"
                name="paymentReason"
                data-cy="paymentReason"
                type="select"
              >
                {paymentReasonValues.map(paymentReason => (
                  <option value={paymentReason} key={paymentReason}>
                    {translate(`tinyMedicRestApp.PaymentReason.${paymentReason}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPayment.gatewayVendor')}
                id="subscription-payment-gatewayVendor"
                name="gatewayVendor"
                data-cy="gatewayVendor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPayment.transactionId')}
                id="subscription-payment-transactionId"
                name="transactionId"
                data-cy="transactionId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPayment.customerId')}
                id="subscription-payment-customerId"
                name="customerId"
                data-cy="customerId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPayment.active')}
                id="subscription-payment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPayment.lastupdated')}
                id="subscription-payment-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPayment.microSec')}
                id="subscription-payment-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPayment.timestampentry')}
                id="subscription-payment-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPayment.cursor')}
                id="subscription-payment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="subscription-payment-subscriptionPlan"
                name="subscriptionPlan"
                data-cy="subscriptionPlan"
                label={translate('tinyMedicRestApp.subscriptionPayment.subscriptionPlan')}
                type="select"
                required
              >
                <option value="" key="0" />
                {subscriptionPlans
                  ? subscriptionPlans.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/subscription-payment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SubscriptionPaymentUpdate;
